"use strict";

/* eslint no-console: 0, no-throw-literal: 0 */
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _planout = _interopRequireDefault(require("planout"));

var _LabSetup = require("./setup/LabSetup");

var Namespace =
/*#__PURE__*/
function (_planout$Namespace$Si) {
  (0, _inherits2.default)(Namespace, _planout$Namespace$Si);

  function Namespace() {
    var _this;

    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2.default)(this, Namespace);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Namespace).call(this, args));

    if (!_this.inputs.app) {
      throw new Error('Please specify an app name');
    }

    return _this;
  }

  (0, _createClass2.default)(Namespace, [{
    key: "get",
    value: function get(param) {
      var labsUserId = (0, _LabSetup.getUserId)();

      if (labsUserId) {
        this.inputs.user_id = labsUserId;
      } else {
        if (window.Raven) {
          var errorMessage = '[hublabs-core] Please specify a user id';
          console.error(errorMessage);
          window.Raven.captureException(new Error(errorMessage));
        }

        return null;
      }

      var arbitraryProps = (0, _LabSetup.getArbitraryProps)();
      var keys = Object.keys(arbitraryProps);

      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        this.inputs[key] = arbitraryProps[key];
      }

      return (0, _get2.default)((0, _getPrototypeOf2.default)(Namespace.prototype), "get", this).call(this, param);
    }
  }, {
    key: "setupExperiments",
    value: function setupExperiments() {
      throw 'IMPLEMENT setupExperiments';
    }
  }, {
    key: "setup",
    value: function setup() {
      throw 'IMPLEMENT setup';
    }
  }, {
    key: "setupDefaults",
    value: function setupDefaults() {
      this.setPrimaryUnit('user_id');
      this.numSegments = 100;
      this.inputs.user_id = (0, _LabSetup.getUserId)();
    }
  }]);
  return Namespace;
}(_planout.default.Namespace.SimpleNamespace);

var _default = Namespace;
exports.default = _default;
module.exports = exports.default;